import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbb537a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-button" }

import { useDomainsStore } from '@/store/domains'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  name: 'ContactButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "b44349b6": (_unref(contactButtonTextColor)),
  "b0a7a85c": (_unref(contactButtonColor))
}))

const domainsStore = useDomainsStore()
const contactButtonColor = computed(
  () => domainsStore.currentDomainSettings.theme.contactButtonColor,
)
const contactButtonTextColor = computed(
  () => domainsStore.currentDomainSettings.theme.contactButtonTextColor,
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})